import "@adeccoux/tag-ds/index.css";
import { Notification, NotificationHeader, NotificationBody } from '@adeccoux/tag-ds';
import React, { useEffect, useState } from "react";

const TostNotification = ({ notificationData, closeTostNotification }) => {
    const { messageTitle, message, status, iconName } = notificationData;
    return (
        <div className="full-width"
            style={{
                width: 'fit-content'
            }} >
            <Notification
                className="docs"
                data-testid="notification"
                iconClose
                onClose={closeTostNotification}
                icon={<span className="material-icons">{iconName}</span>}
                show
                success={status === "success"}
                error={status === "error"}
            >
                <NotificationHeader style={{ lineHeight: "25px" }}>
                    {messageTitle}
                </NotificationHeader>
                <NotificationBody className="tost_message">
                    {message}
                </NotificationBody>
            </Notification>
        </div>
    );

}

export default TostNotification;